
import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext"

import Header from "../components/header"
import Footer from "../components/footer"
import Body from "../components/body"

import CompanyInfo from "../components/companyInfo";
import UsersCount from "../components/usersCount";
import MachinesList2 from "../components/machineList2";
import ProdList1 from "../components/prodlist";
import ShiftList1 from "../components/shiftList";
import ActTypeList1 from "../components/activityTypeList";

const ListActivityType = () => {

  const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));


  return (
    <>
      <div className="body">
        <Header />
        <h2>{t('actType1')}</h2>

        <div>
          <ActTypeList1 id_c={company.id_c} />

        </div>
      </div>
    </>
  )
}

export default ListActivityType;